module.exports = __webpack_public_path__ + "img/icon_currency.3bd136a8.png";